// 分组相关
export const GET_GROUP_LIST = 'GET_GROUP_LIST'
export const SET_GROUP_LIST = 'SET_GROUP_LIST'
export const CREATE_GROUP = 'CREATE_GROUP'
export const EDIT_GROUP = 'EDIT_GROUP'
export const DELETE_GROUP = 'DELETE_GROUP'

// 图标相关
export const GET_ICON_LIST = 'GET_ICON_LIST'
export const SET_ICON_LIST = 'SET_ICON_LIST'
export const DELETE_ICON = 'DELETE_ICON'

export const UPLOAD_ICON_LIST = 'UPLOAD_ICON_LIST'

export const BUILD_ICON = 'BUILD_ICON'
export const GET_BUILD_STATUS = 'GET_BUILD_STATUS'
export const SET_BUILD_STATUS = 'SET_BUILD_STATUS'
export const GET_ICON_STATUS = 'GET_ICON_STATUS'
export const SET_ICON_STATUS = 'SET_ICON_STATUS'

export const STATUS = {
    IS_BUILDING: '构建中',
    SUCCESS: '成功',
    FAIL: '失败'
}
